module.exports = __webpack_public_path__ + "static/media/mountains.77ca7ccd.png";